export default {
    TOAST_NOTIFICATION: 'TOAST_NOTIFICATION',
    PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
};
